<div class="exception-body">

    <div class="ui-lg-6">
        <div class="exception-panel" style="padding-top: 10%;">
            <h1 class="exception-summary"></h1>
            <div class="exception-detail">
                <h4>Your Payment is being processed! Please do not exit or refresh this page.</h4>
                <p-progressSpinner [style]="{ width:'25%', height:'25%'}" animationDuration=0s></p-progressSpinner>

            </div>
            
            
        </div>
    </div>
</div>
